var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.frontpage = {
	init: function() {
		site.owl.init('.box_extras_newData .items', {
			margin: 30,
			dots: false,
			nav: true,
			navText: ['Fletta til baka<i class="fas fa-angle-left"></i>', 'Fletta áfram<i class="fas fa-angle-right"></i>'],
			responsive: {
				0: {
					items: 2
				},
				768: {
					items: 3
				},
				992: {
					items: 4
				},
				1320: {
					items: 5
				}
			}
		})
	}
};

site.extrasMenu = {
	append: function() {
		let currentDivision = $('html').attr('lang');
		if (!currentDivision) {
			return;
		}
		$.ajax({
			url: `/_/${currentDivision}/extras/index/misc1`,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				$('li[class*="extras-"]', '#mainmenu .mmLevel1').each(function() {
					let $this = $(this);
					let classList = $(this).attr('class');
					let result = classList.match(/extras-(\w*)/);

					if (result) {
						let codename = result[1];
						if (codename in response) {
							$this.addClass('children').append(response[codename]);
						}
					}
				});

				$('a[href="' + window.location.pathname + '"]', '#mainmenu').closest('li').addClass('selectedLevel');
				site.nav.init();
				site.megamenu.init();

				$('li.selectedLevel').closest('ul').closest('li').addClass('selectedLevel down');
			}
		})


	}
};

site.goalPopups = {
	init: function() {
		const goalPopupToggles = $('.goalToggle');
		goalPopupToggles.attr('aria-expanded', false).attr('aria-haspopup', true);
		goalPopupToggles.on('click', function() {
			site.goalPopups.closeAll();
			$(this).attr('aria-expanded', true);
			const controls = '#' + $(this).attr('aria-controls');
			$(controls).addClass('open').attr('aria-expanded');
		});

		this.bindCloseClick();
		this.bindBodyClick();
		this.bindEscClick();
	},

	closeAll: function() {
		$('.goalPopup').removeClass('open');
		$('.goalToggle').attr('aria-expanded', false);
	},

	bindCloseClick: function() {
		$('.goalPopup .close').on('click', function() {
			site.goalPopups.closeAll();
		});
	},

	bindBodyClick: function() {
		$(document).on('click touchstart', function(e) {
			var container = $(".goalPopup, .goalToggle");

			if (!container.is(e.target) && container.has(e.target).length === 0) {
				site.goalPopups.closeAll();
			}
		});
	},

	bindEscClick: function() {
		document.addEventListener('keydown', (e) => {
			if (e.code === 'Escape') {
				site.goalPopups.closeAll();
			}
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();
	site.extrasMenu.append();
	site.goalPopups.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	$body.removeClass('preload');
});
